import { combineReducers, configureStore } from '@reduxjs/toolkit';
import userSessionReducer from './slices/UserSession/userSession';
import sideBarReducer from './slices/sideBar/sideBarSlice';
import settingsReducer from './slices/settings/slice';
import UserProfileReducer from './slices/userProfile/userProfileSlice';
import UserStoresReducer from './slices/userStores/slice';
import { SK_userSession } from '../data/config';

const appReducers = combineReducers({
  userSession: userSessionReducer,
  sideBar: sideBarReducer,
  settings: settingsReducer,
  userProfile: UserProfileReducer,
  userStores: UserStoresReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === 'auth/logout') {
    state = undefined;
    localStorage.removeItem(SK_userSession);
  }
  return appReducers(state, action);
};

const store = configureStore({
  reducer: rootReducer,
});

export default store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
